import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { PasswordResetGuard } from './login/guards/password-reset.guard';
import { LoginComponent } from './login/login.component';
import { PasswordRecoveryComponent } from './login/password-recovery/password-recovery.component';
import { PasswordResetComponent } from './login/password-reset/password-reset.component';
import { AuthGuard } from './login/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'password-recovery',
    component: PasswordRecoveryComponent,
  },
  {
    path: 'password/reset/:username/:passwordResetToken',
    component: PasswordResetComponent,
    canActivate: [PasswordResetGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'products',
        loadChildren: () => import('./pages/products/overview/product-overview.module').then((m) => m.ProductOverviewModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
